import { useState } from 'react';
import { resetPasswordWithEmail } from '../services/api';

const generateRandomPassword = () => Math.random().toString(36).slice(-8) + '@1A';

export default function ForgotPasswordModal({ isOpen, onClose }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus('');
    const emailValue = email.trim().toLowerCase();
    if (!emailValue) {
      setStatus('Veuillez saisir votre adresse e-mail.');
      return;
    }
    try {
      const newPassword = generateRandomPassword();
      await resetPasswordWithEmail(emailValue, newPassword);
      setStatus('Un e-mail avec votre nouveau mot de passe a été envoyé.');
      setEmail('');
    } catch (error) {
      setStatus(error.message);
    }
  };

  return (
    <div className="auth-modal" role="dialog" aria-modal="true" aria-label="Mot de passe oublié" onClick={onClose}>
      <div className="auth-modal__panel" onClick={(event) => event.stopPropagation()}>
        <button type="button" className="auth-modal__close" onClick={onClose} aria-label="Fermer">×</button>
        <form className="auth-modal__form" onSubmit={handleSubmit}>
          <h3>Mot de passe oublié ?</h3>
          <p>Indiquez votre adresse e-mail pour recevoir un nouveau mot de passe.</p>
          <label>
            Adresse e-mail
            <input type="email" value={email} onChange={(event) => setEmail(event.target.value)} required />
          </label>
          {status && <p className="auth-modal__error">{status}</p>}
          <button type="submit" className="auth-modal__primary">Envoyer</button>
        </form>
      </div>
    </div>
  );
}
